import React from "react";
import { Table, Alert, Pagination } from "react-bootstrap";
import { LoadingSpinner } from "lib/Spinner";
import "./simpleTable.css";
import { _t, isEn } from "app/i18n/i18n";
import { useSelector } from "react-redux";

export function SimpleTable({
  rows = [],
  hits = 0,
  isLoading,
  isError,
  bodyRows,
  headerRow,
  pageSize = 20,
  onPage,
  filter,
  containerStyle,
  tableStyle,
}) {
  return (
    <>
      <section className="position-relative overflow-auto" style={containerStyle}>
        <Table hover variant="sm text-wrap text-sm small" style={tableStyle}>
          <thead className="thead-grey sticky-row">{headerRow(null)}</thead>
          <tbody>{!isLoading && !isError && bodyRows({ rows })}</tbody>
        </Table>

        {rows.length === 0 && !isLoading && !isError && <NoResultsFound />}
        {isLoading && <LoadingSpinner />}
        {isError && <NotAvailable />}
      </section>
      <PaginationControl hits={hits} pageSize={pageSize} onPage={onPage} filter={filter} />
    </>
  );
}

export function NotAvailable() {
  return (
    <Alert variant="warning mx-auto center-block maxw-400 m-2">
      {isEn() && <Alert.Heading>Service Unavailable</Alert.Heading>}
      {_t("Sorry this data is not currently available, please try again later.")}
    </Alert>
  );
}

export function NoResultsFound() {
  return (
    <Alert variant="light mx-auto center-block maxw-400">
      <Alert.Heading>{_t("No results found.")}</Alert.Heading>
      {_t("Please broaden your search criteria.")}
    </Alert>
  );
}

export function PaginationControl({ hits, pageSize = 20, onPage = noop }) {
  const page = parseInt(useSelector((state) => state.filter.qsFilter).Page, 10) || 1;

  const pages = Math.ceil(hits / pageSize);
  const range = [page - 3, page - 2, page - 1, page, page + 1, page + 2, page + 3].filter((n) => n >= 1 && n <= pages);
  const from = (page - 1) * pageSize;

  const items = range.map((n) => (
    <Pagination.Item
      key={n}
      active={n === page}
      onClick={() => {
        onPage(n, pageSize, from);
        window.scrollTo(0, 0);
      }}
    >
      {n}
    </Pagination.Item>
  ));

  return (
    <section className="text-xs-center mt-2">
      <Pagination className="justify-content-center" size="sm">
        {items}
      </Pagination>
    </section>
  );
}

function noop() {
  return null;
}
